// src/paginas/publico/home/home.tsx
import React from 'react';




import { useEffect } from "react";

function HomePage() {
  useEffect(() => {
    window.location.href = "https://appcodesh.com.br";
  }, []);

  return null; // não renderiza nada
}

export default HomePage;